import { AppVersion } from './interfaces';

export const getAppVersion = (): Promise<AppVersion> => fetch(`${process.env.PUBLIC_URL}/appversion`).then((response) => response.json());
